import { LoginPage } from './login';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: LoginPage
      },
      {
        path: ':data',
        component: LoginPage
      },
    ])
  ],
  exports: [LoginPage],
  declarations: [LoginPage],
})
export class LoginPageModule {}